<div class="dialog-agent">
  <div mat-dialog-content class="">
    <div>
      <div class="w-100 d-inline-block text-center pt-2 pb-4">
        <i class="rt-icon rt-info mb-2 text-info"></i> <br>
        <b class="text-info h4 px-2">{{data.dynamicMessages.title}}</b>
      </div>
    </div>

    <div class="w-100 d-inline-block">
      <p class="p-3 m-0 bg-light text-center text-dark" [innerHTML]="data.dynamicMessages.body"></p>
      <div class="d-inline-block w-100 p-3">
        <mat-checkbox color="primary" [(ngModel)]="doNotShowAgain" (change)="setNewValue($event)">{{ 'GLOBAL.DONT-SHOW-AGAIN' | translate }}</mat-checkbox>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="w-100">
    <button mat-stroked-button color="primary" class="ms-auto" [mat-dialog-close]="data">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CLOSE' | translate }}</span>
    </button>
  </div>
</div>
